import axios from "axios";
import errorHandler from "./errorHandler";

const backEnd = axios.create({
    // baseURL: "http://localhost:8000/api/v1/",
    baseURL: "https://bargesabz-api.liara.run/api/v1/",
});

backEnd.interceptors.response.use(
    (response) => response,

    (error) => {
        const errorKey = errorHandler(error);

        return Promise.reject(errorKey);
    }
);

export default backEnd;
